import api from '@/shared/api/api-client';

import type { AuthUser, Licence, OtpChallenge } from '../domain/login.model';
import type { LoginGateway } from './login.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the login endpoints (kept 1:1 with the original `Login` page / AuthContext
 * calls). The client prefixes `/v1`, and `/v1/auth/*` endpoints are CSRF-exempt
 * and excluded from the 401 auto-refresh. `api.post`/`api.get` unwrap the
 * `{ success, data }` envelope, so these resolve directly to the inner data.
 */
export const httpLoginGateway: LoginGateway = {
  authenticate: (input) => api.post<{ user: AuthUser } | OtpChallenge>('/auth/login', input),
  verifyOtp: (input) => api.post<{ user: AuthUser }>('/auth/verify-otp', input),
  resendOtp: async (otpToken) => {
    await api.post('/auth/resend-otp', { otp_token: otpToken });
  },
  fetchCurrentLicence: () => api.get<Licence>('/licences/current'),
};
